import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { CalendarioPagosPage } from "@/features/calendario-pagos/components/CalendarioPagosPage";
import { calendarioPagosQueryOptions } from "@/features/calendario-pagos/hooks/use-calendario-pagos";

/**
 * Ruta `/calendario-pagos` (P39) · calendario de pagos programados,
 * exclusivo de Mesa de Control (el servidor re-valida siempre). Loader
 * precarga el mes en curso (defaults del backend).
 */
export const Route = createFileRoute("/_authed-tw/calendario-pagos")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(calendarioPagosQueryOptions()),
  component: () => (
    <PermissionGate permisos={[PERMISOS.calendarioPagosVer]}>
      <CalendarioPagosPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
